import React from 'react'

import { SpacingTypes } from 'utils/themes/types'

import { StyledView } from './styled'
import { BoxPadding, BoxProps } from './types'

export const Box = ({
  children,
  padding,
  flex,
  display,
  align,
  justifyContent,
  flexDirection,
  backgroundColor,
  textColor,
  borderRadius,
  maxWidth,
  maxHeight,
  width,
  height,
  shadow,
  style,
  zIndex,
  margin,
  border,
  position,
  ...rest
}: BoxProps) => {
  const paddingSpacing = getSpacing(padding)
  const marginSpacing = getSpacing(margin)
  return (
    <StyledView
      {...rest}
      style={style}
      flex={flex}
      borderRadius={borderRadius}
      backgroundColor={backgroundColor}
      textColor={textColor}
      display={display}
      align={align}
      flexDirection={flexDirection}
      justifyContent={justifyContent}
      shadow={shadow}
      maxWidth={maxWidth}
      maxHeight={maxHeight}
      width={width}
      height={height}
      zIndex={zIndex}
      paddingTop={paddingSpacing.top}
      paddingBottom={paddingSpacing.bottom}
      paddingRight={paddingSpacing.right}
      paddingLeft={paddingSpacing.left}
      marginTop={marginSpacing.top}
      marginBottom={marginSpacing.bottom}
      marginRight={marginSpacing.right}
      marginLeft={marginSpacing.left}
      border={border}
      position={position}
    >
      {children}
    </StyledView>
  )
}

const getSpacing = (spacing?: SpacingTypes | BoxPadding) => {
  let top: SpacingTypes | number | undefined
  let bottom: SpacingTypes | number | undefined
  let left: SpacingTypes | number | undefined
  let right: SpacingTypes | number | undefined

  if (typeof spacing === 'object') {
    if (spacing.vertical) {
      top = spacing.vertical
      bottom = spacing.vertical
    } else {
      top = spacing.top || undefined
      bottom = spacing.bottom || undefined
    }

    if (spacing.horizontal) {
      left = spacing.horizontal
      right = spacing.horizontal
    } else {
      left = spacing.left || undefined
      right = spacing.right || undefined
    }
  } else {
    top = spacing
    bottom = spacing
    left = spacing
    right = spacing
  }

  return {
    top,
    bottom,
    left,
    right,
  }
}
